export const PartyTagResources = {
  getContent: {
    url: "/parties_list",
    asyncActions: {
      init: "getParty_INIT",
      success: "getParty_SUCCESS",
      error: "getParty_ERROR"
    }
  }
};

const initialState = {
  list: undefined,
  status: undefined,
  statusText: undefined,
  deleted: undefined,
  edited: undefined,
  hasList: undefined,
  loading: undefined,
  hasError: undefined
};

export function PartyTag(state = { initialState }, action = {}) {
  const { init, success, error } = PartyTagResources.getContent.asyncActions;
  switch (action.type) {
    case init: {
      return {
        ...state,
        loading: true,
        hasError: undefined
      };
    }

    case success: {
      const {
        data,
        status,
        statusText
      } = action.payload;
      return {
        list: data,
        status,
        statusText,
        deleted: [],
        edited: [],
        hasList: true,
        loading: false,
        hasError: false
      };
    }

    case error: {
      return {
        ...state,
        loading: false,
        hasError: true
      };
    }

    default: {
      return state;
    }
  }
}
